import {message} from 'ant-design-vue';

export const errorMessage = (content: string) => {
  message.error(content);
};
